import { Box, Container, Fab, Typography } from "@mui/material";
import React, { useState } from "react";

import CssBaseline from "@mui/material/CssBaseline";
import AppbarPart from "./parts/AppbarPart";
import HeaderPart from "./parts/HeaderPart";
import GridPart from "./parts/GridPart";
import GridProdukPart from "./parts/GridProdukPart";
import CarouselPart from "./parts/CarouselPart";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Logos from "./assets/logo.jpeg";
import { kirimWA } from "./models/kirimWa";
import ArmadaPart from "./parts/ArmadaPart";
import FooterPart from "./parts/FooterPart";
import TambahanPart from "./parts/TambahanPart";

function App() {
  function handleFab() {
    let txt = "Minta info tentang Gede Pari Trans";
    kirimWA(txt);
  }
  return (
    <React.Fragment>
      <CssBaseline />
      <Box sx={{ p: 2, backgroundColor: "primary.dark" }}>
        <Typography
          color="primary.contrastText"
          variant="h6"
          sx={{ textAlign: { sm: "center" } }}
        >
          GedePari Trans Wisata
        </Typography>
      </Box>
      <Container
        maxWidth="md"
        sx={{ minHeight: "100vh", position: "relative" }}
      >
        <Box sx={{ display: "flex" }}>
          <Box
            component="img"
            src={Logos}
            alt="logos"
            sx={{ p: 2, mx: "auto", width: { xs: "70%", sm: "50%" } }}
          />
        </Box>
        <CarouselPart />
        <HeaderPart />
        <GridPart />
        <GridProdukPart />
        <TambahanPart />
        <ArmadaPart />
        <FooterPart />

        <Fab
          onClick={handleFab}
          variant="extended"
          size="medium"
          color="success"
          aria-label="wa"
          sx={{ position: "fixed", bottom: 20, right: 10 }}
        >
          <WhatsAppIcon sx={{ mr: 1 }} />
          Hubungi Admin
        </Fab>
      </Container>
    </React.Fragment>
  );
}

export default App;
